// extracted by mini-css-extract-plugin
export default {"contenedor":"alert_contenedor__renhr"};